module.exports=`
$
ज़रूर
रद्द करना
जमा करना
दैनिक ब्याज दर
निवेश चक्र
आकाश
आरंभिक राशि
परियोजना का पैमाना
अभी निवेश करें
प्रगति पूर्ण है
आय
निवेश राशि
मुखपृष्ठ
संपत्ति
गतिविधि
व्यक्तिगत केंद्र
खोज
दाखिल करना
मेरी टीम
मैं रिचार्ज करना चाहता हूँ
निकालना
जोखिम नियंत्रण
गोपनीयता नीति
उपयोगकर्ता का समझौता
हमारे बारे में
दैनिक आय
अधिक
सरल और सुविधाजनक, यहां तक कि नौसिखिए भी निवेश कर सकते हैं
आक्रामक और रक्षात्मक दोनों तरह से काफ़ी मुनाफ़ा
सभी
नौसिखियों के लिए अनुशंसित
लोकप्रिय निवेश
मजबूत निवेश
उच्चस्तरीय चयन
वैश्विक नेतृत्व निवेश
कृपया निवेश राशि दर्ज करें
कोई डेटा नहीं
नमस्ते प्रिय
कुल संपत्ति
प्रिंसिपल प्राप्त करना होगा
ब्याज वसूल किया जाना है
संचयी आय
मेरा निवेश
लेनदेन का विवरण
ऑनलाइन सेवा
उपलब्ध शेष राशि
लबालब भरना
निकालना
मेरा पर्स
रिचार्ज रिकार्ड
निकासी रिकार्ड
मित्रों को आमंत्रित करें
अकाउंट सेटिंग
खोज इतिहास
अभी तक कोई खोज इतिहास नहीं
कोई खोज इतिहास नहीं मिला
खाता प्रबंधन
ईमेल प्रमाणीकरण
सत्यापित
प्रमाणीकरण पर जाएँ
बटुआ प्रबंधन
भाषा प्राथमिकता
लॉगिन पासवर्ड बदलें
भुगतान पासवर्ड बदलें
चालू खाते से लॉग आउट करें
निवेश रिकॉर्ड
अभी तक कोई निवेश रिकॉर्ड नहीं
पुरा होना
प्रगति पर है
खाते में प्रवेश
लॉग इन करें
पंजीकरण करवाना
कृपया ईमेल पता दर्ज करें
अपना पासवर्ड दर्ज करें
पासवर्ड याद
पासवर्ड भूल जाओ
तुरंत लॉग इन करें
कृपया ईमेल पता दर्ज करें
अपना पासवर्ड दर्ज करें
ईमेल पता प्रारूप ग़लत है
लॉग इन सफल
एक खाता दर्ज करो
लॉग इन करें
पंजीकरण करवाना
कृपया ईमेल पता दर्ज करें
अपना पासवर्ड दर्ज करें
कृपया सत्यापन कोड दर्ज करें
सत्यापन कोड भेजें
सफलतापूर्वक भेज दिया
कृपया अनुशंसाकर्ता का खाता नंबर दर्ज करें, वैकल्पिक
अभी साइनअप करें
कृपया ईमेल पता दर्ज करें
अपना पासवर्ड दर्ज करें
कृपया सत्यापन कोड दर्ज करें
आपने सफलतापूर्वक पंजीकरण कर लिया है, कृपया लॉग इन करें
लॉगिन पासवर्ड पुनः प्राप्त करें
कृपया अपना ईमेल इनपुट करें
कृपया सत्यापन कोड दर्ज करें
सत्यापन कोड प्राप्त करें
कृपया नया लॉगिन पासवर्ड दर्ज करें
अभी संशोधित करें
कृपया अपना ईमेल इनपुट करें
सफलतापूर्वक भेज दिया
कृपया नया लॉगिन पासवर्ड दर्ज करें
कृपया सत्यापन कोड दर्ज करें
सफलतापूर्वक संशोधित
आपने कुल मिलाकर साइन इन किया है
आकाश
एक
दो
तीन
चार
पाँच
छह
दिन
आज का साइन-इन इनाम
नकद
सीधे खाते की शेष राशि पर
संचयी साइन-इन पुरस्कार
ध्यान दें: इनाम के लाल लिफाफे सीधे आपके खाते की शेष राशि में भेजे जाएंगे, कृपया ध्यान से जांचें!
पाना
अब साइन इन करो
सफलतापूर्वक साइन इन करें
प्राप्त करें
प्राप्त
नष्ट कर दिया
पुरस्कार परिचय
प्रथम-स्तरीय सदस्यता पुनर्भरण, पुरस्कार

दूसरे स्तर की सदस्यता पुनर्भरण, पुरस्कार

स्तर 3 सदस्यता पुनर्भरण, पुरस्कार

कुल इनाम
टीम
प्रदर्शन
लोग
आमंत्रण लिंक
स्तर 1
लेवल 2
स्तर तीन
पिक्चर को सेव करना
संदेश केंद्र
अपठित संदेश
संदेश विवरण
खाता पुनर्भरण
मेरा उपलब्ध शेष
कृपया रिचार्ज राशि दर्ज करें
कृपया भुगतान का तरीका चुनें
अगला कदम
कृपया भुगतान का तरीका चुनें
रिचार्ज राशि खाली या इससे कम नहीं हो सकती

रिचार्ज आवृत्ति बहुत अधिक है
रिचार्ज सफल
रिचार्ज विफल रहा
खाता पुनर्भरण
पता:
मात्रा:
रिचार्ज निर्देश:
बटुए का पता
वॉलेट पता कॉपी करें
रिचार्ज आवेदन सफलतापूर्वक सबमिट हो गया
सफलतापूर्वक कॉपी किया गया
रिचार्ज राशि ट्रांसफर करने के लिए QR कोड को स्कैन करें
कॉपी
खाता नाम:
कार्ड संख्या:
किनारा:
खाते से निकासी
बटुआ निकालो
कृपया बटुआ चुनें
निकाली गयी राशि
उपलब्ध नकदी की मात्रा
एक नया निकासी वॉलेट जोड़ें
सिस्टम द्वारा निकासी की स्वचालित रूप से समीक्षा और प्रक्रिया की जाती है और 30 मिनट के भीतर पहुंचने की उम्मीद है, कृपया धैर्यपूर्वक प्रतीक्षा करें! !
वापसी आवेदन की समीक्षा चल रही है
कृपया एक निकासी खाता चुनें
निकासी राशि खाली नहीं हो सकती
निकासी राशि ऋणात्मक संख्या नहीं हो सकती
निकासी की राशि शेष राशि से अधिक नहीं हो सकती
निकासी पासवर्ड खाली नहीं हो सकता
निकासी आवेदन सफल
संचालन शुल्क
कृपया पहले अपना वॉलेट पासवर्ड सेट करें!
अभी सेट करें
बटुआ प्रबंधन
एक बंधा हुआ बटुआ
नया बटुआ जोड़ें
नया बटुआ जोड़ें
बटुआ प्रकार
बटुए का पता
कृपया बटुए का पता दर्ज करें
बचाना
सफलतापूर्वक जोड़ा गया
कृपया बटुए का पता दर्ज करें
कृपया वॉलेट क्यूआर कोड अपलोड करें
कृपया 2M के भीतर चित्र अपलोड करें
केवल jpg और png छवि अपलोड का समर्थन करता है
सफलतापूर्वक अपलोड हो गया
अपलोड विफल
वॉलेट क्यूआर कोड
कृपया आईएफएससी दर्ज करें
अलीपे खाता:
कृपया अपना Alipay खाता नंबर दर्ज करें
Alipay भुगतान कोड
हम चैट नंबर:
कृपया WeChat आईडी दर्ज करें
WeChat भुगतान कोड
नाम :
कृपया कार्डधारक का नाम दर्ज करें
कार्ड संख्या:
कृपया कार्ड नंबर दर्ज करें
शाखा :
कृपया शाखा दर्ज करें
मेरा पर्स
रिचार्ज रिकार्ड
निकासी रिकार्ड
कुल शेष
में स्थानांतरण
बाहर स्थानांतरण
ईमेल सत्यापित करें
खाता सुरक्षा सुनिश्चित करने के लिए, कृपया ईमेल सत्यापन पूरा करें
सत्यापन कोड
सत्यापन कोड भेजें
सफलतापूर्वक भेज दिया
पूर्ण सत्यापन
भरना होगा
सत्यापन सफल
लॉगिन पासवर्ड बदलें
नया लॉगिन पासवर्ड सेट करें
बाउंड ईमेल का उपयोग करके सत्यापित करें
सत्यापित करने के लिए मूल पासवर्ड का उपयोग करें
बाध्य ईमेल पता:
कृपया ईमेल सत्यापन कोड दर्ज करें
सत्यापन कोड भेजें
कृपया मूल लॉगिन पासवर्ड दर्ज करें
कृपया एक नया पासवर्ड दर्ज करें
कृपया नये पासवर्ड की पुष्टि करें
परिवर्तनों की पुष्टि करें
सफलतापूर्वक भेज दिया
मूल लॉगिन पासवर्ड खाली नहीं हो सकता
नया लॉगिन पासवर्ड खाली नहीं हो सकता
पासवर्ड की पुष्टि करें और नया लॉगिन पासवर्ड असंगत हैं
सफलतापूर्वक संशोधित
लॉगिन पासवर्ड का उपयोग करके सत्यापित करें
भुगतान पासवर्ड बदलें
नया भुगतान पासवर्ड सेट करें
अपना पासवर्ड दर्ज करें
लॉगिन पासवर्ड खाली नहीं हो सकता
कृपया 6 शुद्ध संख्याएँ दर्ज करें
नया भुगतान पासवर्ड खाली नहीं हो सकता
पुष्टिकरण पासवर्ड और नया भुगतान पासवर्ड असंगत हैं
कृपया शुद्ध संख्याएं दर्ज करें`